<template>
  <div class="newsWapper">
    <div class="DetailMsg main">
      <h3>{{baseData.title}}</h3>
      <div class="smallTit">
        <!-- <p class="smallTitOne clearfix">
          <span v-if="this.baseData.viewCount!=''" class="fr">阅读人数：{{baseData.viewCount}}</span>
        </p> -->
        <p class="smallTitTwo clearfix">
          <span v-if="this.baseData.author!=''" class="fl">
            作者：{{this.baseData.sender}}
            <!-- <em v-if="this.authorRank!=''">({{authorRank}})</em> -->
          </span>
          <span v-if="this.baseData.publishTime!=''" class="fr">发布时间：{{baseData.publishTime}}</span>
        </p>
      </div>
      <!-- <div class="detailInfo" v-html="DetailInfo"></div> -->
      <div class="detailInfo">
        <div v-html="baseData.content" v-if="baseData.contentType=='text'"   @click="imgChange($event)"></div>
        <a :href="`${baseData.content}`" v-if="baseData.contentType=='url'"></a>
      </div>
    </div>

    <!-- <discuss-box :ktId="newsId" v-if="this.newsType == 'other'" /> -->

    <refresh-page v-if="refreshPage" />
  </div>
</template>

<script>
/*eslint-disable*/
import { mapState, mapMutations } from "vuex";
import { isIphonex } from "@/utils/common";
import { getDeviceType } from "@/common/getDeviceType/getDeviceType";
const refreshPage = () => import("@/components/common/refreshPage");
// const discussBox = () => import("@/components/common/discussBox");
export default {
  name: "wxNewsDetail",
  data() {
    return {
      orgId: "",
      baseData: {},
      newsId: "", //新闻Id
      newsType: "", //新闻type
      iphonexType: "", //是否是苹果X
      refreshPage: false,
      collectId: "", //收藏Id
      clientType: ""
    };
  },
  components: {
    // discussBox,
    refreshPage
  },
  mounted() {
    this.newsId = this.$route.query.commonId;
    this.orgId = this.$route.query.orgId;

    document.title = "动态";
    this.initNewsDetail();
    this.clientType = getDeviceType();
    this.iphonexType = isIphonex();
  },
  methods: {
    ...mapMutations(["setShowLoad"]),
    initNewsDetail() {
      let _this = this;
      this.setShowLoad(false); //加载状态，默认为true加载
      // if (_this.newsType == "other") {
      _this.getOtherDetail();
      // } else {
      //   _this.getBaikeDetail();
      // }
    },
    getOtherDetail() {
      let _this = this;
      _this.$api.baseCommon.Msg.infoMsg({
        id: _this.newsId,
        orgId: _this.orgId,
        type: "1"
      })
        .then(res => {
          if (res.code == "1") {
            console.log(res.data);
            if (res.data != null) {
              _this.baseData = Object.assign({}, _this.baseData, res.data);
            }
            
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
          _this.refreshPage = true;
        });
    },
    getBaikeDetail() {
      let _this = this;
      _this.$api.News.baikeNewsDetail(_this.newsId)
        .then(res => {
          if (res.code == "1" && res.data != null) {
            _this.mainSource = res.data.source || "";
            _this.mainReadNumber = res.data.readNum || "";
            _this.mainAuthor = res.data.author || "";
            _this.authorRank = "";
            _this.publishTime = res.data.createTime || "";
            _this.DetailTit = res.data.title || "";
            _this.DetailInfo = res.data.content || "";
            _this.isRead = res.data.isRead || "";
            _this.countDownShow = true;
            _this.countDown();
            _this.collectId = res.data.collectId ? res.data.collectId : 0;
          } else {
            console.log(res.msg);
          }
        })
        .catch(err => {
          console.log(err);
          _this.refreshPage = true;
        });
    },
    addReadNews() {
      let _this = this;
      _this.$api.News.newsReadRecord({
        id: _this.newsId
      })
        .then(res => {
          if (res.code == "1") {
            _this.mainReadNumber = parseFloat(_this.mainReadNumber) + 1;
            console.log(res.data);
          }
        })
        .catch(err => {
          console.log(err);
        });
    },
    //放大富文本图片
    imgChange(e) {
      let imgs = [];
      this.baseData.content.replace(
        /<img [^>]*src=['"]([^'"]+)[^>]*>/g,
        function(match, capture) {
          imgs.push(capture);
        }
      );
      if (e.target.nodeName == "IMG") {
         let indexInfo = e.target.currentSrc;
         let showIndex = "";
         imgs.forEach((item,index) => {
            if(indexInfo==item){
              showIndex = index;
            }
         });
        let data = {
          showImgs: imgs,
          swipercliclIndex: showIndex,
          swiperShow: true
        };
        this.$store.commit("setDataImgs", data);
      } else {
        return;
      }
    },
  },
  computed: {
    ...mapState(["showLoad", "userinfo"])
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.newsWapper {
  width: 100%;
  font-family: "PingFangSC-Regular";
  .main {
    width: 95%;
    margin: 0 auto;
  }
  .smallTit {
    padding-bottom: 10px;
    border-bottom: 1px solid #4bc08a;
    p {
      margin-top: 5px;
      span {
        font-size: 10px;
      }
      em {
        font-weight: normal;
      }
    }
  }
  .DetailMsg {
    margin-top: 20px;
    border-bottom: 1px solid rgba(235, 235, 235, 1);
    padding-bottom: 16px;
  }
  .DetailMsg h3 {
    font-size: 18px;
    font-family: "PingFangSC-Medium";
    font-weight: 600;
    color: rgba(3, 3, 3, 1);
    line-height: 25px;
    text-align: center;
  }
  .DetailTime {
    display: inline-block;
    margin-top: 12px;
    font-size: 13px;
    font-weight: 400;
    color: rgba(3, 3, 3, 1);
    line-height: 18px;
    opacity: 0.4;
    span {
      display: inline-block;
      margin-right: 4px;
    }
  }
  .DetailMsg {
    .detailInfo {
      margin-bottom: 75px;
      > div {
        margin-top: 20px;
        img {
          width: 100%;
          height: 100%;
          margin: 0 auto;
          display: block;
        }
        p {
          margin-top: 18px;
          font-size: 14px;
          font-family: "PingFangSC-Regular";
          font-weight: 400;
          color: rgba(3, 3, 3, 1);
          line-height: 20px;
          opacity: 0.7;
        }
      }
    }
  }
}
</style>
